var Vue = require('vue');
require('./MaskedInput.js');

Vue.directive('ui-mask', {
    params: ['format'],
    bind: function () {
        VMasker(this.el.getElementsByTagName('input')[0]).maskPattern(this.params.format);
    }
});